import axios from "axios";
import { configUrl } from "config";

// Update enquiry by ID
export default async function updateEnquiry(enquiryId, data) {
    try {
        const res = await axios.put(`${configUrl.AssessmentServer}/api/Enquiry/updateEnquiry/${enquiryId}`, data);
        return res.data;
    } catch (err) {
        console.error("Error in updateEnquiry:", err);
        throw err;
    }
}
